import { FormControl } from '@angular/forms';

export type HeadbandControls = {
  id: FormControl;
  content: FormControl;
  startDate: FormControl;
  endDate: FormControl;
  transporters: FormControl;
  transporterIds: FormControl;
  type: FormControl;
};

export interface IHeadband {
  id?: number;
  content?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
  transporters?: number[] | null;
  transporterIds?: string | null;
  type?: string | null;
}

export class Headband implements IHeadband {
  constructor(
    public id?: number,
    public content?: string | null,
    public startDate?: Date | null,
    public endDate?: Date | null,
    public transporters?: number[] | null,
    public transporterIds?: string | null,
    public type?: string | null
  ) {}
}

export function getMessageIdentifier(message: IHeadband): number | undefined {
  return message.id;
}
